import { Goal, Timestamp } from '@griply/types';

import { filterGoals } from './goals/filter-goals';

export type DeadlineGoal = Goal & { deadline: Timestamp };

export type GetDeadlineGoalsOptions = {
  showCompleted?: boolean;
};

const hasDeadline = (goal: Goal): goal is DeadlineGoal => !!goal.deadline;

const byDeadlineThenNameThenId = (a: DeadlineGoal, b: DeadlineGoal) =>
  a.deadline.getTime() - b.deadline.getTime() ||
  a.name.localeCompare(b.name) ||
  a.id.localeCompare(b.id);

// Needs the FULL goal set — archived/completed are inherited from ancestors.
export const getDeadlineGoals = (
  goals: Goal[],
  { showCompleted }: GetDeadlineGoalsOptions,
): DeadlineGoal[] =>
  filterGoals(goals, { hideArchived: true, hideCompleted: !showCompleted })
    .filter(hasDeadline)
    .sort(byDeadlineThenNameThenId);
